import { Reveal } from '../components/Reveal';
import { PILLARS } from '../data/pillars';

export function Pillars() {
  return (
    <section className="block" data-screen-label="03 Piliers">
      <div className="wrap">
        <div className="sec-head">
          <div><div className="sec-num"><b>03</b> &nbsp; principes</div></div>
          <div className="sec-tag">CONVICTIONS — 03</div>
        </div>
        <Reveal as="h2" className="sec-title">Trois <em>convictions</em> qui tiennent.</Reveal>
        <div className="pillars">
          {PILLARS.map((p) => (
            <Reveal key={p.num} className="pillar">
              <span className="num">{p.num}</span>
              <div className="word">{p.word}</div>
              <h3>{p.title}</h3>
              <p>{p.body}</p>
              <div className="meta">{p.meta}</div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
